
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'Мәтіндік бөлік',
	'noDashboardFound': 'Оқиға шығарылмайды. Енді мұнда жоқ немесе оны көру үшін артықшылықтарыңыз жеткіліксіз.',
	'noDashboardCapability': 'Оқиғаларды қолдану мүмкіндігіңіз жоқ',
	'noDashboardPermision': 'Бұл оқиғаны көру үшін жеткілікті артықшылықтарыңыз жоқ',
	'defaultName': 'Жаңа мәтіндік бөлік',
	'storyProperties': 'Мәтіндік бөліктің сипаттары',
	'createAvDataStoryLabel': 'Мәтіндік бөлік',
	'createAvSlideShowLabel': 'Слайд көрсету',
	'createAvPanAndZoomLabel': 'Басқарылатын саяхат',
	'dashboard_save_success': 'Сіздің оқиғаңыз сақталды.',
	'cmEmptySelection': 'Оқиға жойылды. Жаңа оқиға ретінде сақтауға тырысыңыз.',
	'createStoryTitle': 'Мәтіндік блокты құру',
	'transitionStyleTitle': 'Өтпелі мәнер',
	'createButton': 'Жасау',
	'cancelButton': 'Болдырмау',
	'dashboardResetTitle': 'Оқиғаны қалпына келтіру',
	'dashboardResetMessage': 'Осы оқиғаға қолданылған барлық өзгерістерді қалпына келтіргіңіз келетініне сенімдісіз бе?',
	'dashboardResetToast': 'Сіздің оқиғаңыз қалпына келтірілді.',
	'filter_drag_and_drop_all_tabs': 'Барлық көріністерді сүзгілеу үшін деректерді сүйреп апарыңыз.',
	'filter_drag_and_drop_current_tab': 'Бұл көріністі сүзгілеу үшін деректерді сүйреп апарыңыз.',
	'filterIconLabel_Global': 'Барлық көріністер',
	'filterIconLabel_Tab': 'Бұл көрініс',
	'filterIconTooltip_Global': 'Барлық көріністер',
	'filterIconTooltip_Tab': 'Бұл көрініс',
	'filterOverflowMenu_Global': 'Барлық қойындылардың толып кету мәзірі',
	'filterOverflowMenu_Tab': 'Осы көріністің толып кету мәзірі',
	'renameScene': 'Сеанстың атын өзгерту',
	'duplicateScene': 'Сеансты көшіру',
	'deleteScene': 'Сеансты жою',
	'editTimelineHighlight': 'Бөлектеуді өңдеу',
	'deleteTimelineHighlight': 'Бөлектеуді жою',
	'filter_includesAll': 'Барлығын қамтиды',
	'timeline_highlight_moved_to': '%{id} уақыт жолын бөлектеу %{time} элементіне жылжыды',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Таңдау',
	'newDefaultStoryName': 'Оқиға: %{modelName}',
	'exportLabel': 'Сақтау',
	'exportAsLabel': 'Сияқты сақтау:',
	'exportDialogTitle': 'Оқиға ретінде сақтаңыз',
	'exportDialogFooter': 'Сақтау жәнпе болдырмау түймешіктері',
	'loadAfterExportLabel': 'Сақталғаннан кейін оқиғаны ашыңз',
	'selectTemplateLabel': 'Үлгіні таңдау',
	'outOfBoundsWarningMessage': 'Кейбір бақылау тақтасының виджеттері тордан тыс және экспортталғаннан кейін дұрыс көрсетілмеуі мүмкін.',
	'emptyExploreCardsWarningMessage': 'Оқиға ретінде сақтау кезінде бос карталар жойылды.',
	'dashboard_export_success': 'Сіздің бақылау тақтаңыз оқиға ретінде сәтті сақталды.',
	'explore_export_success': 'Сіздің зерттеуіңіз тарих ретінде сәтті сақталды.',
	'toastUpgradeDone': 'Сіздің оқиғаңыз жаңартылды. Оңтайлы өнімділікті қолдау үшін қазір сақтаңыз.',
	'navigationMarker': 'Шарлау таңбалауышы',
	'navigateMarkers': 'Шарлау таңбалауыштары',
	'navNextMarker': 'Келесі таңбалауыш',
	'navPrevMarker': 'Алдыңғы таңбалауыш',
	'navPrevMarkerAbbreviated': 'Алдыңғы таңбалауыш',
	'timelineSettingsButton': 'Ойнату параметрлері',
	'autoPlay': 'Барлық көріністерді ойнатыңыз',
	'loop': 'Цикл',
	'refreshData': 'Басында жаңартыңыз',
	'slideshowLabel': 'Слайд көрсетілімі',
	'panAndZoomLabel': 'Басқарылатын саяхат',
	'slideShowLayoutLabel': 'Слайд көрсетілімінің орналасуы',
	'panAndZoomLayoutLabel': 'Нұсқалған саяхат орналасуы',
	'panAndZoomLayoutFooter': 'Басқарылатын саяхат орны бір кенепте орындалған көріністер жыйнағы болып табылады. Осы оқиға түрін жегу кезінде көрсетілім әрбір жеке көріністерде тізбекті тәртіп ретінде кескінді масштабын өзгертеді және панарамдайды. Бұл слайд шоу орналасынан түрленеді, ол жерде әр көрініс жаңа кенепте көрсетілген. Басқарылатын саяхат орналаспен жолдар арқылы қосылған үш көрініс көлденең ретінде көріністерді құруға рұқсат береді. Бұл уақыт шкаласын көрсетуге пайдалы.',
	'PanAndZoomLayout1': '5-көріністер тіктөртбұрыш кескінінде орнатылады',
	'PanAndZoomLayout2': '4-көріністер сол жақтан оң жаққа көтерілетін баспалдақ кескініне орналасқан',
	'PanAndZoomLayout3': '6-көріністер тіктөртбұрыш кескінінде орнатылады',
	'PanAndZoomLayout4': '7-көріністер төмендегі 1 үлкен көрініспен және жоғарыдағы 6 кішкентай көріністермен тіктөртбұрыш кескінге орналасқан.',
	'PanAndZoomLayout5': '3-көріністер төмендегі 2 үлкен көрініспен және жоғарыдағы 1 кішкентай көріністермен орналасқан.',
	'PanAndZoomLayout6': '4-көріністер тізбегі көлденең орналасқан',
	'pageSelectWarning': 'Сеансты таңдаңыз.',
	'noSceneTransitionLabel': 'Ешбір',
	'sceneTransitionPropertyLabel': 'Көрініс өтуі',
	'animatedPathSceneTransitionLabel': 'Анимацияланған жол',
	'sweepSceneTransitionLabel': 'Бұрылу',
	'storyTypeLabel': 'Оқиға түрі',
	'layoutLabel': 'Орналасу',
	'tabName_animation': 'Анимация',
	'propAniAnimation': 'Анимация',
	'propAniTypeEntrance': 'Кіру анимациясы',
	'propAniDirectionIn': 'Кіру бағыты',
	'propAniTypeExit': 'Анимациядан шығу',
	'propAniDirectionOut': 'Бағыттан шығу',
	'propAniDirection': 'Бағыт',
	'propAniEntrance': 'Кіру',
	'propAniTypeEntranceSlideIn': 'Келесіге жүгірту',
	'propAniTypeEntranceFadeIn': 'Күшейту',
	'propAniTypeEntrancePivotIn': 'Ішіне айналу',
	'propAniTypeEntranceScaleIn': 'Келесідегі ауқым',
	'propAniTypeEntranceShrinkIn': 'Кішірейту',
	'propAniDirectionInLeft': 'Сол жақтан',
	'propAniDirectionInRight': 'Оң жақтан',
	'propAniDirectionInTop': 'Жоғарыдан',
	'propAniDirectionInBottom': 'Төменнен',
	'propAniExit': 'Шығу',
	'propAniTypeExitSlideIn': 'Сырғыту',
	'propAniTypeExitFadeIn': 'Жоғалу',
	'propAniTypeExitPivotOut': 'Сыртқа айналу',
	'propAniTypeExitScaleIn': 'Масштабтау',
	'propAniTypeExitExpandOut': 'Сыртқа кеңейту',
	'propAniDirectionOutLeft': 'Сол жаққа',
	'propAniDirectionOutRight': 'Оң жаққа',
	'propAniDirectionOutTop': 'Жоғарыға',
	'propAniDirectionOutBottom': 'Төменге',
	'propAniEntranceTime': 'Бастау (secs):',
	'propAniExitTime': 'Аяқтау (secs):',
	'animationNoEntranceText': 'Егер виджет сенанстың басында болса, кіріс анимациясы орын алмайды.',
	'animationNoExitText': 'Виджет сеанстың соңында болғанда, анимациядан шығу мүмкін болмайды.',
	'propAniTypeDataEntrance': 'Деректерді енгізу',
	'propAniRevealDuration': 'Кіру анимациясының ұзақтығы',
	'timelineAnimationProperties': 'Анимация сипаттарын ашу',
	'scenesPropertiesSection': 'Сеанстар',
	'editStoryCoachMarkTitle': 'Өңдеу мәтіндік бөлігі',
	'editStoryCoachMarkContents': 'Бұл мәтіндік бөлікті өңдеуге қаламсап белгішесін басыңыз.',
	'addDataStoryCoachMarkContents': 'Мәтіндік бөлікке деректер тақтасынан деректерді апарып салыңыз.',
	'expandSceneCoachmarkTitle': 'Уақыт шкаласын ашу',
	'expandSceneCoachmarkContents': 'Уақыт және ұзақтығына негізделген нысан көрінісін реттеу арқылы көріністі жандандырыңыз.',
	'overviewCoachmarkTitle': 'Көріністерді шолу',
	'overviewCoachmarkContents': 'Жалпы көріністі көрсету үшін көріністерді шолуыны оқиғаңыздың басында және аяғында пайдаланыңыз. Көріністерді шолудан басқа көріністермен ауыстыру үшін оны басыңыз және сүйреңіз. Көріністер шолуыны оқіға сипаттарында көрсете немесе жасыра аласыз.',
	'animatedPathCoachmarkTitle': 'Анимацияланған жол',
	'animatedPathCoachmarkContents': 'Нысаны бар көріністі көшірмелеу арқылы бір көріністен өзгесіне нысан анимациясын жасаңыз. Содан кейін, жаңа көріністе көшірілген нысанды жылжытыңыз, өлшемін өзгертіңіз немесе айналдырыңыз.',
	'propShowStoryOverviewFirstSlide': 'Барлық оқиғаларды басында көрсету',
	'propShowStoryOverviewLastSlide': 'Барлық оқиғаларды соңында көрсету',
	'storySceneSingleCountLabel': '1 сцена',
	'storySceneCountLabel': '%{count} сенанс',
	'storySceneRangeCountLabel': '%{count} -ден %{index} сеансы',
	'storySceneExpand': 'Уақыт шкаласын ашу',
	'storySceneActionMenu': 'Көрініс опцияларының мәзірін іске қосу',
	'timelineRightContainerLabel': 'Уақыт шкаласы батырмасын бақылау тобы',
	'timelineViewLabel': 'Уақыт шкаласы',
	'timelineZoomFit': 'Сәйкес болғанша үлкейту',
	'timelineZoomIn': 'Ұлғайту',
	'timelineZoomOut': 'Кішірейту',
	'timelinePositionIndicator': '%{position} уақыт кестесінің орын индикаторы',
	'timelinePositionIndicatorMoveLeftTo': 'Уақыт кестесінің орналасу көрсеткішін солға %{position} жылжыту',
	'timelinePositionIndicatorMoveRightTo': 'Уақыт кестесінің орналасу көрсеткішін оңға %{position} жылжыту',
	'sceneStart': 'Сценаның басына %{position}-ға барыңыз',
	'sceneEnd': 'Сценаның соңына %{position}-ға барыңыз',
	'timelineHighlightTitle': 'Бөлектеу',
	'addTimelineHighlight': 'Бөлектеуді қосу',
	'addSceneBtnTitle': 'Әдепкі үлгі бойынша жаңа сеансты қосыңыз',
	'addSceneChevronBtnTitle': 'Сеанс үлгісін таңдаңыз',
	'timelinePlay': 'Ойнау',
	'timelinePause': 'Үзіліс',
	'sceneNavigation': 'Сценаны шарлау',
	'navNextScene': 'Келесі сцена',
	'navPrevScene': 'Алдыңғы сцена',
	'navPrevSceneAbbreviated': 'Бастапқы сцена',
	'navExitFullScreen': 'Толық экран режимінен шығу',
	'navToggleOverview': 'Қарап шығуды ажырата қосу',
	'rowNumber': '%{number} жолы',
	'overviewBtnLabel': 'Жалпы шолу',
	'sceneListStart': 'Шолуды бастау',
	'sceneListEnd': 'Шолу соңы',
	'timelineLeftHandle': '%{name} үшін сол жақ тұтқасы',
	'timelineRightHandle': '%{name} үшін оң жақ тұтқасы',
	'timelineLeftHandleNoTitle': 'сол жақ таңбалауыш',
	'timelineRightHandleNoTitle': 'оң жақ таңбалауыш',
	'timelineMoveLeft': '%{object} солға жылжытыңыз',
	'timelineMoveRight': '%{object} оңға жылжытыңыз',
	'timelineMoveWidget': 'уақыт шкаласы виджеті %{newStartTime} және %{newEndTime} ішіне жылжытылған',
	'timelineMoveWidgetStartTime': 'уақыт шкаласы виджеті басталу уақыты %{newStartTime} мәніне өзгертілген',
	'timelineMoveWidgetEndTime': 'уақыт шкаласы виджеті аяқталу уақыты %{newEndTime} мәніне өзгертілген',
	'timelineMoveWidgetDown': 'уақыт шкаласы виджеті төмен жылжытылған',
	'timelineMoveWidgetUp': 'уақыт шкаласы виджеті жоғары жылжытылған',
	'addSceneTitle': 'Сценаны қосу',
	'blankSceneLayout': 'Бос',
	'titleSceneLayout': 'Тақырыпмен тақырыпшалар',
	'sceneLayout1': 'Бір көрнекілендірудің жанында мәтінмен тақырып',
	'sceneLayout2': 'Бір көрнекілендірумен тақырып',
	'sceneLayout3': 'Екі көрнекілендірумен тақырып',
	'sceneLayout4': 'Көп_мақсатты',
	'sceneLayout5': 'Бір көрнекілендірудің жанында мәтінмен тақырып жоқ',
	'sceneLayout6': 'Көп мақсатты 2 ден 2',
	'sceneLayout7': 'Көп мақсатты 2 жанында 1',
	'sceneLayout8': 'Көп мақсатты 1 жанында 2',
	'sceneLayout9': '2 үстінде көп мақсатты 1',
	'sceneLayout10': '1 үстінде көп мақсатты 2',
	'sceneLayout11': '1 үстінде көп мақсатты 4',
	'sceneLayout12': '1 үстіндегі 2- ден 2 жанындағы көп мақсатты 1',
	'titleWidgetPlaceholderText': 'Тақырыбыңызды осында енгізіңіз',
	'subtitleWidgetPlaceholderText': 'Тақырыпшаңызды осында енгізіңіз',
	'createStoryViewTitle': 'Мәтіндік бөлікті жасау',
	'defaultStoryName': 'Жаңа мәтіндік бөлік',
	'screenshot_label': '%{title}Оқиғасы',
	'screenshot_label_scene': '%{title} оқиғасының %{sceneTitle} сеансы',
	'filmstripHandleOpenLabel': 'Сцена таңдаушысын ашу',
	'filmstripHandleCloseLabel': 'Сцена таңдаушысын жабу'
});
